export const userCookies = {
  C_ID: 'c_id',
  CUSTOMER_DATA: 'customer_data'
};
